import React, { useState } from 'react';

import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';


import ClipLoader from 'react-spinners/ClipLoader';

const override = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
};

  
import FormRow from './FormRow';

const NewAirport = () => {
    const [rowsSubmit, setRowsSubmit] = useState([{ id: Date.now(), from: '', to: '', date: null, time: '', passenger: '1', bags: '1' }]);
    const [rows, setRows] = useState([{ id: Date.now(), from: '', to: '', date: null, time: '', passenger: '1', bags: '1' }]);
    const [errors, setErrors] = useState([{ from: '', to: '', date: null, time: '' }]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isValidAirport, setValidAirport] = useState('');
    const [isDivVisible, setIsDivVisible] = useState(false);
    const [errorFields, setErrorFields] = useState([false]);
    const [error, setError] = useState('');
    

    const handleChange = (id, name, value) => {
        const updatedRows = rows.map((row) => (row.id === id ? { ...row, [name]: value } : row));
        setRows(updatedRows);
        validateForm(updatedRows);
        //console.log(updatedRows);
    };

    const handleAddRow = () => {
        
        const newRow = {
            id: Date.now(),
            from: '',
            to: '',
            date: null,
            time: '',
            passenger: '1',
            bags: '1'
        };
        setRows([...rows, newRow]);
        setIsButtonDisabled(true);
        setErrorFields([...errorFields, false]);
        setIsDivVisible(false);
    };

    const handleRemoveRow = (id) => {
        const updatedRows = rows.filter((row) => row.id !== id);
        setRows(updatedRows);
        validateForm(updatedRows);

        //Update errorFields to match the filtered rows
        const newErrorFields = errorFields.filter((_, row) => row.id !== id);
        setErrorFields(newErrorFields);
    };


    const validateForm = (rows) => {
        //console.log(rows);
        let isValid = true;
        const newErrors = rows.map(row => ({
            from: '',
            to: '',
            date: '',
            time: ''
        }));
        const newErrorFields = rows.map(() => false);
        rows.forEach((row, index) => {
            if (!row.from) {
                isValid = false;
                setValidAirport('Please complete your journey details');
                newErrors[index].from = 'Please select a valid "From" location.';
                newErrorFields[index] = true;
                setSuccessMessage('');

                //console.warn(`Row "From" field is empty.`);
            }
            if (!row.to) {
                isValid = false;
                setValidAirport('Please complete your journey details');
                newErrors[index].to = 'Please select a valid "To" location.';
                newErrorFields[index] = true;
                setSuccessMessage('');

                //console.warn(`Row "To" field is empty.`);
            }
            if (!row.date) {
                isValid = false;
                setValidAirport('Please complete your journey details');
                newErrors[index].date = 'Please select a valid date.';
                newErrorFields[index] = true;
                setSuccessMessage('');
            }
            if (!row.time) {
                isValid = false;
                setValidAirport('Please complete your journey details');
                newErrors[index].time = 'Please select a valid time.';
                newErrorFields[index] = true;
                setSuccessMessage('');
            }
            if (row.from && row.to && row.date && row.time) {
                setValidAirport('');
            }
        });
        setErrors(newErrors);
        setErrorFields(newErrorFields);
        setIsButtonDisabled(!isValid);
    };   

    const handleNextClick = () => {
        // Handle next step logic here
        const newErrorFields = rows.map(() => false); // Initialize a new array with false
        rows.forEach((row, index) => {
            //console.log(row);
            if (!row.from) {
                //console.warn(`Row ${index + 1}: "From" field is empty.`);                
                newErrorFields[index] = true;
                setValidAirport('Please complete your journey details');
                setSuccessMessage('');
                //console.warn(isValidAirport);
            }
            if (!row.to) {
                //console.warn(`Row ${index + 1}: "To" field is empty.`);
                newErrorFields[index] = true;
                setValidAirport('Please complete your journey details');
                setSuccessMessage('');
                //console.warn(isValidAirport);
            }
            if (!row.date) {
                //console.warn(`Row ${index + 1}: "Date" field is empty.`);
                newErrorFields[index] = true;
                setValidAirport('Please complete your journey details');
                setSuccessMessage('');
            }
            if (!row.time) {
                //console.warn(`Row ${index + 1}: "Time" field is empty.`);
                newErrorFields[index] = true;
                setValidAirport('Please complete your journey details');
                setSuccessMessage('');
            }
        });
        setErrorFields(newErrorFields);
        const hasErrors = newErrorFields.some(field => field);
        //console.warn(hasErrors);


        if (isButtonDisabled) {
            setValidAirport('Please complete your journey details');
            setIsDivVisible(false);
        } else {
            setValidAirport('');
            setIsDivVisible(true);
        }

    };

    /************Extra Field**************/
    const [valuePhone, setValuePhone] = useState();    
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [nameError, setNameError] = useState(''); 
    const [namelastError, setNameLastError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [emailError, setEmailError] = useState(''); 

    const handleChangePhone = (phoneNumber) => {
        setValuePhone(phoneNumber);
        if (phoneNumber) {
          if (!isPossiblePhoneNumber(phoneNumber)) {
            setPhoneError('Invalid phone number length');
            setExtraFields({ ...extraFields, phone: '' });
            //console.log("hello 1"+ phoneNumber);
          } else {
            if(valuePhone && isValidPhoneNumber(phoneNumber)){
              setPhoneError('');
              setValuePhone(phoneNumber);
              setExtraFields({ ...extraFields, phone: phoneNumber });
              //console.log("hello 2"+ phoneNumber);
            }else{
              setPhoneError('Invalid Phone number');
              setExtraFields({ ...extraFields, phone: '' });
              //console.log("hello 4"+ phoneNumber);          
            }
            
          }
        } else {
          setPhoneError('Phone number required');
          setExtraFields({ ...extraFields, phone: '' });
          //console.log("hello 3"+ phoneNumber);      
        }
      };


      const [extraFields, setExtraFields] = useState({
        title: 'Mr',
        name: '',
        lastname: '',
        phone: '',
        email: '',
        message: '',
      });

      const handleExtraFieldChange = (e) => {
        const { name, value } = e.target;
        setExtraFields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));

        if (name === 'name') setNameError('');
        if (name === 'lastname') setNameLastError('');
        if (name === 'phone') setPhoneError('');
        //if (name === 'email') setEmailError('');
        if (name === 'email') {
            setEmailError('');
            if (!/\S+@\S+\.\S+/.test(value)) {
                setEmailError('Email address is invalid');
            }
            //validateForm_extra(value);
            setSuccessMessage('');
        }       
        //console.log(extraFields);
      };

      const validateForm_extra = () => {
        let isValid = true;
        if (!extraFields.name) {
            isValid = false;
          setNameError('First Name field is required');
        }
        if (!extraFields.lastname) {
            isValid = false;
          setNameLastError('Last Name field is required');
        }    
        if (!extraFields.phone) {
            isValid = false;
          setPhoneError('Phone field is required');
        }
        if (!extraFields.email) {
            isValid = false;
          setEmailError('Email field is required');
          //console.log('Email field is required');
        } else if (!/\S+@\S+\.\S+/.test(extraFields.email)) {
            isValid = false;
          setEmailError('Email address is invalid');
          //console.log('Email address is invalid');
        } 
        //return Object.keys(errors).length === 0;
        return isValid;
      };


    //const handleSubmit = (event) => {
    const handleSubmit = async (event) => {
        event.preventDefault();

        const valid = rows.every((row) => row.from && row.to && row.date && row.time);
        const isValidExtra = validateForm_extra();
        //console.log(isValidExtra);
        if (valid && isValidExtra) {
            setLoadingSubmit(true); 
            // Perform form submission logic here            
            const formData = {
                rows,
                ...extraFields,
            };
            console.log('Form submitted:', formData);

            try {
                const response = await fetch(`${airportappLocalizer.apiUrl}/airport/v1/airenquiry`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
                });
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                const data = await response.json();
                //console.log('Form submitted:', data);
                setSuccessMessage(data);
                setExtraFields({
                    title: 'Mr',
                    name: '',
                    lastname: '',
                    phone: '',
                    email: '',
                    message: '',
                });
                setValuePhone('');
                setPhoneError(''); 
                setRows([{ id: Date.now(), from: '', to: '', date: null, time: '', passenger: '1', bags: '1' }]);
                setValidAirport('');
                setIsButtonDisabled(true);
      
      
            } catch (error) {
                setError('Failed to submit data: ' + error.message);
                //console.log('Failed to submit data: ' + error.message);
            } finally {
                setLoadingSubmit(false); // Stop the loader
            }


        } /*else {
            console.log('Form contains errors. Please correct them.');
            setError('Failed to submit data: ' + error.message);
        }*/
    };


    return (
        <div className="booking-form-cont">
            <div className="cust-container">
                <form onSubmit={handleSubmit} autoComplete="off" className="booking-form">
                    <div className="search-flight-cont">
                        {rows.map((row, index) => (
                            <FormRow                                
                                key={row.id}
                                index={row.id}
                                errorfield={errorFields[index]}
                                row={row}
                                handleChange={handleChange}
                                handleRemove={handleRemoveRow}
                                showDeleteButton={rows.length > 1}
                            />
                        ))}

                        <div className="form-bottom-btn-cont">
                            <a onClick={handleAddRow} className="common-btn btn-add-return" href="javascript:void(0)" id="">
                                <img src={airportappLocalizer.icon_add} height="20" width="20" alt="Delete" /> Add Leg / Return
                            </a>
                            <a onClick={handleNextClick} className="common-btn btn-search nextstep_fordetails" href="javascript:void(0)" id="">Get a Quote</a>
                        </div>
                        {isValidAirport && <div className="main-errorjs-validation" style={{ color: 'red' }}>
                            <span className='valid-errorjs'><i class="fa-solid fa-circle-exclamation"></i></span>
                            {isValidAirport}</div>
                        }

                    </div>
                    {isDivVisible && (
                        <div className="request-flight-cont">
                            <div className="cust-row">
                                <div className="cust-col cust-col-6">
                                    <div className="cust-form-group">
                                        <label className="cust-form-label">Title</label>
                                        <select 
                                            className="cust-form-control select-title" 
                                            name="title"
                                            value={extraFields.title}
                                            onChange={handleExtraFieldChange}
                                        >
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Miss</option>
                                            <option value="Dr">Dr</option>
                                        </select>
                                    </div>
                                    <div className="cust-form-group">
                                        <label className="cust-form-label">First Name</label>
                                        <input className="cust-form-control" 
                                            type="text" 
                                            autoComplete="new-password"
                                            autoCorrect="off"
                                            name="name"
                                            value={extraFields.name}
                                            onChange={handleExtraFieldChange}
                                            placeholder="First name"                                            
                                        />
                                        {nameError && <div className="error-validation" style={{ color: 'red' }}>{nameError}</div>}
                                    </div>
                                    <div className="cust-form-group">
                                        <label className="cust-form-label">Last Name</label>
                                        <input
                                            className="cust-form-control"
                                            autoComplete="new-password"
                                            autoCorrect="off"
                                            type="text"
                                            name="lastname"
                                            value={extraFields.lastname}
                                            onChange={handleExtraFieldChange}
                                            placeholder='Last name'
                                        />
                                        {namelastError && <div className="error-validation" style={{ color: 'red' }}>{namelastError}</div>}
                                    </div>
                                    <div className="cust-form-group">
                                        <label className="cust-form-label">Email</label>
                                        <input
                                            className="cust-form-control"
                                            autoComplete="new-password"
                                            autoCorrect="off"
                                            type="email"
                                            name="email"
                                            value={extraFields.email}
                                            onChange={handleExtraFieldChange}
                                            placeholder='Email'
                                        />
                                        {emailError && <div className="error-validation" style={{ color: 'red' }}>{emailError}</div>}
                                    </div>
                                    <div className="cust-form-group group-phone">
                                        <label className="cust-form-label">Phone</label>                                        
                                        <PhoneInput
                                            placeholder="Enter phone number"
                                            value={valuePhone}
                                            onChange={handleChangePhone}                                
                                            international
                                            name="phone"
                                            countryCallingCodeEditable={true}
                                            defaultCountry="GB"
                                            error={phoneError}
                                        />
                                        {phoneError && <div className="error-validation" style={{ color: 'red' }}>{phoneError}</div>}                                        
                                    </div>
                                </div>
                                <div className="cust-col cust-col-6">
                                    <h3 className="title-additional">Any additional requests that we may assist you with?</h3>
                                    <p className="sub-title-additional">For example, specific aircraft request.</p>
                                    <div className="cust-form-group">
                                        <textarea 
                                            className="cust-form-control"
                                            name="message"
                                            value={extraFields.message}
                                            onChange={handleExtraFieldChange}
                                            placeholder="Message"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="cust-form-group">
                                <input className="common-btn btn-request-flight" type="submit" value="REQUEST FLIGHT" />
                                {loadingSubmit && <ClipLoader cssOverride={override} size={50} aria-label="Loading Spinner" data-testid="loader" className="airport_insert_loader reactjs_loader"/>}
                                {successMessage && <span className='submit-success' style={{ color: 'green' }}>{successMessage}</span>}
                                {error && <span className='submit-error' style={{ color: 'red' }}>{error}</span>}
                            </div>
                        </div>
                    )}

                </form>
            </div>
        </div>
    );
};

export default NewAirport;
